module.exports = __webpack_public_path__ + "media/images/logo_footer-6fdf30749242fc84b5a125419b5405cb.png";